import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import BellGif from "assets/gif/bell.gif";
import { Button, CloseIcon } from "components";
import { useGlobalStore } from "controller";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { dayjs } from "utilz";
import { debugConsole, openBookADemo } from "utilz/helpers";

export const TrialPeriodBanner = ({
  trialEndDate,
}: {
  trialEndDate?: string | null;
}) => {
  const trialEnd = useGlobalStore((state) => state.trialEndDate);
  const role = useGlobalStore((state) => state.role);
  const [show, setShow] = useState(() => {
    const trialBanner = localStorage.getItem("trialBanner");
    if (!trialBanner) return true;
    const { date } = JSON.parse(trialBanner);
    return !dayjs(date).isToday();
  });
  const navigate = useNavigate();
  const theme = useTheme();
  const isSuperAdmin = role === "SUPERADMIN";

  const handleOnClose = () => {
    const date = dayjs().toDate();
    localStorage.setItem("trialBanner", JSON.stringify({ date }));
    setShow(false);
  };

  const handleSubscribe = () => {
    try {
      navigate("/app/control-center/subscription");
    } catch (error) {
      debugConsole(error);
    }
  };

  const endDate = trialEndDate || trialEnd;

  if (!(show && endDate)) return null;
  if (dayjs().isAfter(endDate)) return null;
  if (dayjs(endDate).diff(dayjs(), "day") >= 10) return null;

  const daysLeft = dayjs(endDate).diff(dayjs(), "day") + 1;

  return (
    <Stack
      sx={{
        flexShrink: 0,
        backgroundColor: theme.palette.primitive.system.violet[100],
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        p: "4px 32px",
      }}
    >
      <Stack direction="row" gap="16px" alignItems="center" minWidth={0}>
        <img
          src={BellGif}
          alt="trial reminder"
          style={{ width: "20px", height: "20px" }}
        />
        <Typography
          variant="body-medium"
          noWrap
          sx={{ color: theme.palette.primitive.system.violet[800] }}
        >
          You have {daysLeft} {daysLeft === 1 ? "day" : "days"} left in your
          DeskDay Platform + AI free trial.
          {!isSuperAdmin && " Contact your admin to subscribe."}
        </Typography>
      </Stack>
      <Stack direction="row" gap="16px" alignItems="center" flexShrink={0}>
        {isSuperAdmin && (
          <>
            <Button variant="ghost" isLink onClick={openBookADemo}>
              Book a demo
            </Button>
            <Button variant="primary" onClick={handleSubscribe}>
              Subscribe now
            </Button>
          </>
        )}
        <IconButton
          aria-label="Dismiss trial banner"
          onClick={handleOnClose}
          sx={{
            width: "20px",
            height: "20px",
            ":hover": {
              bgcolor: "transparent",
            },
          }}
        >
          <CloseIcon
            sx={{ width: "20px", height: "20px" }}
            htmlColor={theme.palette.lightBg.high}
          />
        </IconButton>
      </Stack>
    </Stack>
  );
};
